<div fxLayout="column" class="heading">
  <span class="width">{{heading}}</span>
  <p class="width">
    {{description}}
  </p>
</div>

<div style="margin-top: 10vh; justify-content: center;" fxLayout="row wrap">
  <div class="main-div width" fxLayout="row wrap" fxLayoutGap="grid">
    <div class="user_card" fxFlex="19%" fxFlex.md="22%" fxFlex.lt-md="24%" fxFlex.xs="60%" fxFlex.sm="35%" *ngFor="let item of data"
      (click)="openDialog(item)">
      <div class="logo-container">
        <div class="brand_logo_container">
          <img src="{{ item.thumbnail }}" class="brand_logo" alt="Logo" />
        </div>
      </div>
      <div class="form_container">
        <div class="title">
          <span> {{ item.name }}</span>
        </div>
        <div class="profile">
          <span> {{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
  <div fxLayout="column" class="main-container">
    <div class="close-icon-container">
      <button class="close-icon" (click)="dialogRef.close()">
        <i class="bi bi-x-lg" style="font-size: 28px;"></i>
      </button>
    </div> <br>
    <div class="custom-dialog-container" fxLayout="row">
      <div class="image-container">
        <img class="image" src="{{ data.image }}" alt="image">
      </div>
      <div fxFlex="100%" class="flex-column">
        <p class="cname">{{ data.name }}</p>
        <p class="modal-title">{{ data.title }}</p>
        <p class="bio" [innerHTML]="data.bio"></p>
      </div>
    </div>
  </div>
</ng-template>